import {
  GET_PENDING_RECEIVED_VOUCHER_START,
  GET_PENDING_RECEIVED_VOUCHER_SUCCESS,
  GET_PENDING_RECEIVED_VOUCHER_ERROR,
} from 'constants/action-types/transactions/getPendingReceivedVoucher';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_PENDING_RECEIVED_VOUCHER_START:
      return {
        ...state,
        pendingReceivedVoucher: {
          ...state.pendingReceivedVoucher,
          loading: true,
          error: null,
        },
      };
    case GET_PENDING_RECEIVED_VOUCHER_ERROR:
      return {
        ...state,
        pendingReceivedVoucher: {
          ...state.pendingReceivedVoucher,
          error: payload,
          loading: false,
        },
      };
    case GET_PENDING_RECEIVED_VOUCHER_SUCCESS:
      return {
        ...state,
        pendingReceivedVoucher: {
          ...state.pendingReceivedVoucher,
          error: null,
          loading: false,
          data: payload,
        },
      };
    default:
      return null;
  }
};
